module.exports = __webpack_public_path__ + "img/vuexy-login-bg.04351a33.jpg";